import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWorkflowQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type GetWorkflowQuery = {
  __typename?: 'Query';
  workflow?: {
    __typename: 'Workflow';
    id: any;
    name: string;
    description?: string | null;
    version: number;
    enabled: boolean;
    updatedAt: any;
    createdAt: any;
    viewportState: {
      __typename?: 'ViewportState';
      x: number;
      y: number;
      zoom: number;
    };
    graphEdges: {
      __typename: 'WorkflowEdgeConnection';
      totalCount: number;
      edges: Array<{
        __typename: 'WorkflowGraphEdgeEdge';
        cursor: string;
        node: {
          __typename: 'WorkflowGraphEdge';
          id: any;
          sourceId: any;
          targetId: any;
          sourceHandle?: string | null;
          targetHandle?: string | null;
          createdAt: any;
          updatedAt: any;
        };
      }>;
      pageInfo: {
        __typename: 'PageInfo';
        hasPreviousPage: boolean;
        hasNextPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
    };
    graphNodes: {
      __typename: 'WorkflowNodeConnection';
      totalCount: number;
      edges: Array<{
        __typename: 'WorkflowNodeEdge';
        cursor: string;
        node:
          | {
              __typename: 'ActionNode';
              id: any;
              label?: string | null;
              position: any;
              styleData: any;
              createdAt: any;
              updatedAt: any;
              inputs: Array<{
                __typename?: 'WorkflowNodeSlot';
                key: string;
                dataType?: Types.SlotDataType | null;
                direction: Types.SlotDirection;
                optional: boolean;
              }>;
              outputs: Array<{
                __typename?: 'WorkflowNodeSlot';
                key: string;
                dataType?: Types.SlotDataType | null;
                direction: Types.SlotDirection;
                optional: boolean;
              }>;
              controlFlows: Array<{
                __typename?: 'WorkflowNodeSlot';
                key: string;
                dataType?: Types.SlotDataType | null;
                direction: Types.SlotDirection;
                optional: boolean;
              }>;
              action:
                | {
                    __typename?: 'DiscordMessageAction';
                    id: any;
                    name: string;
                    actionType: Types.ActionType;
                    createdAt: any;
                    updatedAt: any;
                    discordMessage: {
                      __typename?: 'DiscordMessage';
                      id: any;
                      content: string;
                      createdAt: any;
                      updatedAt: any;
                      webhook?: {
                        __typename?: 'Webhook';
                        id: any;
                        url: string;
                        createdAt: any;
                      } | null;
                    };
                  }
                | { __typename?: 'EmailAction' }
                | { __typename?: 'SlackMessageAction' }
                | { __typename?: 'WebhookAction' };
            }
          | {
              __typename: 'DelayNode';
              id: any;
              label?: string | null;
              position: any;
              styleData: any;
              createdAt: any;
              updatedAt: any;
            }
          | {
              __typename: 'EnricherNode';
              id: any;
              label?: string | null;
              position: any;
              styleData: any;
              createdAt: any;
              updatedAt: any;
            }
          | {
              __typename: 'FilterNode';
              id: any;
              label?: string | null;
              position: any;
              styleData: any;
              createdAt: any;
              updatedAt: any;
            }
          | {
              __typename: 'MergeNode';
              id: any;
              label?: string | null;
              position: any;
              styleData: any;
              createdAt: any;
              updatedAt: any;
            }
          | {
              __typename: 'SignalNode';
              id: any;
              label?: string | null;
              position: any;
              styleData: any;
              createdAt: any;
              updatedAt: any;
              outputs: Array<{
                __typename?: 'WorkflowNodeSlot';
                key: string;
                dataType?: Types.SlotDataType | null;
                direction: Types.SlotDirection;
                optional: boolean;
              }>;
              controlFlows: Array<{
                __typename?: 'WorkflowNodeSlot';
                id: any;
                key: string;
                dataType?: Types.SlotDataType | null;
                direction: Types.SlotDirection;
                optional: boolean;
              }>;
              signal: {
                __typename?: 'Signal';
                id: any;
                name: string;
                signalType: Types.SignalType;
                fingerprints: Array<
                  | {
                      __typename?: 'BlockFingerprint';
                      operation: Types.ConditionOperator;
                      blockField: string;
                      value: {
                        __typename?: 'FingerprintValue';
                        valueType: Types.FingerprintValueType;
                        value: any;
                      };
                    }
                  | {
                      __typename?: 'LogFingerprint';
                      operation: Types.ConditionOperator;
                      logField: Types.LogField;
                      value: {
                        __typename?: 'FingerprintValue';
                        valueType: Types.FingerprintValueType;
                        value: any;
                      };
                    }
                  | {
                      __typename?: 'TransactionFingerprint';
                      operation: Types.ConditionOperator;
                      txField: Types.TransactionField;
                      value: {
                        __typename?: 'FingerprintValue';
                        valueType: Types.FingerprintValueType;
                        value: any;
                      };
                    }
                >;
              };
            }
          | {
              __typename: 'SubWorkflowNode';
              id: any;
              label?: string | null;
              position: any;
              styleData: any;
              createdAt: any;
              updatedAt: any;
            }
          | {
              __typename: 'TransformerNode';
              id: any;
              label?: string | null;
              position: any;
              styleData: any;
              createdAt: any;
              updatedAt: any;
              transformer: {
                __typename?: 'Transformer';
                id: any;
                name: string;
                transformerType: Types.TransformerType;
              };
            };
      }>;
      pageInfo: {
        __typename: 'PageInfo';
        hasPreviousPage: boolean;
        hasNextPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
    };
  } | null;
};

export const GetWorkflowDocument = gql`
  query GetWorkflow($id: UUID!) {
    workflow(id: $id) {
      id
      name
      description
      version
      enabled
      viewportState {
        x
        y
        zoom
      }
      graphEdges {
        edges {
          cursor
          node {
            id
            sourceId
            targetId
            sourceHandle
            targetHandle
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
          __typename
        }
        totalCount
        __typename
      }
      graphNodes {
        edges {
          cursor
          node {
            __typename
            ... on SignalNode {
              id
              label
              position
              styleData
              createdAt
              updatedAt
              outputs {
                key
                dataType
                direction
                optional
              }
              controlFlows {
                id
                key
                dataType
                direction
                optional
              }
              signal {
                id
                name
                signalType
                fingerprints {
                  ... on BlockFingerprint {
                    blockField: field
                    operation
                    value {
                      valueType
                      value
                    }
                  }
                  ... on TransactionFingerprint {
                    txField: field
                    operation
                    value {
                      valueType
                      value
                    }
                  }
                  ... on LogFingerprint {
                    logField: field
                    operation
                    value {
                      valueType
                      value
                    }
                  }
                }
              }
            }
            ... on TransformerNode {
              id
              label
              position
              styleData
              createdAt
              updatedAt
              transformer {
                id
                name
                transformerType
              }
            }
            ... on ActionNode {
              id
              label
              position
              styleData
              createdAt
              updatedAt
              inputs {
                key
                dataType
                direction
                optional
              }
              outputs {
                key
                dataType
                direction
                optional
              }
              controlFlows {
                key
                dataType
                direction
                optional
              }
              action {
                ... on DiscordMessageAction {
                  id
                  name
                  actionType
                  createdAt
                  updatedAt
                  discordMessage {
                    id
                    content
                    createdAt
                    updatedAt
                    webhook {
                      id
                      url
                      createdAt
                    }
                  }
                }
              }
            }
            ... on EnricherNode {
              id
              label
              position
              styleData
              createdAt
              updatedAt
            }
            ... on FilterNode {
              id
              label
              position
              styleData
              createdAt
              updatedAt
            }
            ... on DelayNode {
              id
              label
              position
              styleData
              createdAt
              updatedAt
            }
            ... on MergeNode {
              id
              label
              position
              styleData
              createdAt
              updatedAt
            }
            ... on SubWorkflowNode {
              id
              label
              position
              styleData
              createdAt
              updatedAt
            }
            __typename
          }
          cursor
          __typename
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
          __typename
        }
        totalCount
        __typename
      }
      updatedAt
      createdAt
      __typename
    }
  }
`;

/**
 * __useGetWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkflowQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowQuery,
    GetWorkflowQueryVariables
  > &
    (
      | { variables: GetWorkflowQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(
    GetWorkflowDocument,
    options,
  );
}
export function useGetWorkflowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowQuery,
    GetWorkflowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(
    GetWorkflowDocument,
    options,
  );
}
export function useGetWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowQuery,
        GetWorkflowQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(
    GetWorkflowDocument,
    options,
  );
}
export type GetWorkflowQueryHookResult = ReturnType<typeof useGetWorkflowQuery>;
export type GetWorkflowLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowLazyQuery
>;
export type GetWorkflowSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowSuspenseQuery
>;
export type GetWorkflowQueryResult = Apollo.QueryResult<
  GetWorkflowQuery,
  GetWorkflowQueryVariables
>;
